const SubCategoryShimmer = () => {
  return (
    <div className="flex gap-3 overflow-hidden">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="w-[100px] md:w-[140px]">
          <div className="h-20 bg-gray-300 rounded animate-pulse mb-2"></div>
          <div className="h-3 bg-gray-300 rounded w-3/4 mx-auto"></div>
        </div>
      ))}
    </div>
  );
};

export default SubCategoryShimmer;
